import React, { useState } from 'react'
import classes from './Sort.module.sass'
import { IconButton } from '../iconButton/IconButton'
import sort from '../../../assets/images/icons/swap.svg'
import { useSort } from './hooks/useSort'
import { Button } from '../button/Button'
import { selectDarkTheme } from '../../../store/slices/settingsSlice'
import { useSelector } from 'react-redux'
import { SortOption, SortParams } from '../../types/interfaces'

type Props = {
  onChange: (value: SortParams) => void
  options: SortOption[] | []
  value: SortParams
  activateFilters: () => void
}

export const Sort = ({ onChange, options, value, activateFilters }: Props) => {
  const { expanded, toggleExpanded } = useSort()
  const dark = useSelector(selectDarkTheme)

  return (
    <div>
      {expanded && (
        <div className={classes.ContainerWrapper} onClick={(e) => e.stopPropagation()}>
          <div className={dark ? classes.ContainerDark : classes.Container}>
            <div className={classes.Title}>Сортировка</div>
            <div className={classes.SortOptions}>
              {options.map((el) => (
                <label className={!dark ? classes.Radio : classes.RadioDark} key={el.value}>
                  <input
                    type="radio"
                    value={el.value}
                    checked={value.sort === el.value}
                    onChange={(e) => {
                      onChange({ sort: e.target.value, order: value.order })
                    }}
                  />
                  {el.name}
                </label>
              ))}

              <label className={!dark ? classes.Radio : classes.RadioDark}>
                <input
                  type="radio"
                  value={'ASC'}
                  checked={value.order === 'ASC'}
                  onChange={(e) => {
                    //@ts-ignore
                    onChange({ sort: value.sort, order: e.target.value })
                  }}
                />
                По убыванию
              </label>
              <label className={!dark ? classes.Radio : classes.RadioDark}>
                <input
                  type="radio"
                  value={'DESC'}
                  checked={value.order === 'DESC'}
                  onChange={(e) => {
                    //@ts-ignore
                    onChange({ sort: value.sort, order: e.target.value })
                  }}
                />
                По возрастанию
              </label>
            </div>
            <div className={classes.ButtonContainer}>
              <Button
                text="Применить"
                onClick={() => {
                  activateFilters()
                  toggleExpanded()
                }}
                small
              />
            </div>
          </div>
        </div>
      )}
      <IconButton onClick={toggleExpanded} icon={sort} alt="Сортировка" display />
    </div>
  )
}
